import { render } from "./ClassList.vue?vue&type=template&id=6b2c92f7&scoped=true"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"

import "./ClassList.vue?vue&type=style&index=0&id=6b2c92f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2c92f7"]])

export default __exports__